import { render, staticRenderFns } from "./delxxzp.vue?vue&type=template&id=695cf225&scoped=true&"
import script from "./delxxzp.vue?vue&type=script&lang=js&"
export * from "./delxxzp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695cf225",
  null
  
)

export default component.exports